export enum ButtonEvents {
  REQUEST_START = '@button/REQUEST_START',
  REQUEST_END = '@button/REQUEST_END',
  LIKE = '@button/LIKE',
  COMMENT = '@button/COMMENT',
}
